import { useCallback } from 'react'
import { calcMagnetizePosition, magnetizeDrag } from './utils'
import { useMagnetizingLine } from 'components/MagnetizingLine/use-magnetizing-line'
import { useIsScrolling } from './use-is-scrolling'
import { useTimelineContext } from 'context/TimelineContext'

export const useTimelineMagnetize = () => {
  const { scrollableContainerRef, magnetizingLineRef } = useTimelineContext()

  const { handleMagnetizingLine, hide: hideMagnetizingLine } =
    useMagnetizingLine(magnetizingLineRef)

  const isScrolling = useIsScrolling(scrollableContainerRef)

  const doMagnetize = useCallback(
    (deltaX: number, currentPosition: number, breakpoints: number[]) => {
      if (isScrolling) return deltaX

      const magnetizePosition = calcMagnetizePosition(
        deltaX,
        currentPosition,
        breakpoints
      )

      handleMagnetizingLine(
        magnetizePosition.isMagnetizing,
        magnetizePosition.magnetizePosition
      )

      return magnetizePosition.deltaX
    },
    [handleMagnetizingLine, isScrolling]
  )

  const magnetizeDragWrapper = useCallback(
    (
      deltaX: number,
      currentItemInitialLeft: number,
      currentItemInitialRight: number,
      breakpoints: number[]
    ) =>
      magnetizeDrag(
        deltaX,
        currentItemInitialLeft,
        currentItemInitialRight,
        breakpoints,
        doMagnetize
      ),
    [doMagnetize]
  )

  return {
    magnetizeDrag: magnetizeDragWrapper,
    magnetizeLeftResize: doMagnetize,
    magnetizeRightResize: doMagnetize,
    hideMagnetizingLine
  }
}
